<p-dialog header="{{ 'businessStatus.details.businessHistory.dialogHeader' | translate }}" [(visible)]="dialogVisible"
          (onHide)="onDialogHide()" [style]="{ width: '70rem', height: 'auto' }" [resizable]="false" [modal]="true"
          appendTo="body"
          [draggable]="true" [contentStyle]="{ overflow: 'visible' }">
  <div class="p-3">
    @if (messageState()) {
      <div class="mb-3">
        <p-message id="business-history-message" variant="outlined" [severity]="messageState()?.severity">
          {{ messageState()?.message }}
        </p-message>
      </div>
    }
    <div class="flex flex-row justify-content-between mb-5">
      <div class="flex flex-column gap-2">
        <div class="flex flex-row align-items-center">
          <label for="kunde_name" class="flex w-10rem">{{ "administration.customer.bank" | translate }}</label>
          <input id="kunde_name" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="geschaeft?.kunde?.name ?? ''" />
        </div>
        <div class="flex flex-row align-items-center">
          <label for="tradeId"
                 class="justify-content-start w-10rem">{{ "businessStatus.details.businessNumber" | translate }}</label>
          <input id="tradeId" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="geschaeft?.murexId" />
        </div>
        <div class="flex flex-row align-items-center">
          <label for="tradeId"
                 class="justify-content-start w-10rem">{{ "businessStatus.tableHeader.businessType" | translate }}</label>
          <input type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]=" 'common.productLabel.' + geschaeft?.typ?.richtung + '_' + geschaeft?.typ?.simpleHgType | translate" />
        </div>
      </div>
      <div class="flex align-self-start">
        <div class="flex flex-row align-items-center">
          <label for="date" class="w-5rem">{{ "administration.ricMds.date" | translate }}</label>
          <input id="date" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="currentDate| date: 'dd.MM.yyyy'" />
        </div>

      </div>
    </div>

    @if (geschaeftshistorie && geschaeftshistorie.length > 0) {
      <p-table class="mt-3 w-full" [value]="geschaeftshistorie" [paginator]="true" [rows]="100"
               [rowsPerPageOptions]="[10, 25, 50, 100, 250]">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "businessStatus.details.businessHistory.dateTime" | translate }}
            </th>
            <th>{{ "businessStatus.details.businessHistory.businessNumber" | translate }}
            </th>
            <th>{{ "businessStatus.details.businessHistory.inventor" | translate }}
            </th>
            <th>{{ "businessStatus.details.businessHistory.art" | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-geschaeft>
          <tr>

            <td>{{ geschaeft.datum ? (geschaeft.datum | date: 'dd.MM.yyyy HH:mm') + ' Uhr' : '' }}</td>
            <td>{{ geschaeft.murexId }}</td>
            <td>{{ geschaeft.traderId }}</td>
            <td>{{ ("businessStatus.details." + geschaeft.status) | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <div class="flex justify-content-center w-full mt-3 border-1 border-solid surface-border border-round p-3">
        <span>{{ 'businessStatus.details.businessHistory.noEntries' | translate }}</span>
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <p-button severity="secondary" variant="outlined" label="{{ 'common.close' | translate }}" class="mr-auto ml-3"
              (onClick)="dialogVisible = false" />
  </ng-template>
</p-dialog>
